import React, { useContext } from "react";
import { EditorContext, ModalServiceContext, UploadContext, useDevService } from "./../../ricos-context";
import { handleImageUpload } from "./../handle-image-upload";
import { IMAGE_EDITOR_MODAL_ID } from "../consts";
import { setupImageEditor } from "../imageStudio/image-editor-logic";
const ImageEditorModal = ({ nodeId, config, src }) => {
  const modalService = useContext(ModalServiceContext) || {};
  const { uploadService } = useContext(UploadContext) || {};
  const { getPublicCommands } = useContext(EditorContext);
  const devService = useDevService();
  const id = "imageEditor";
  React.useEffect(() => {
    const onClose = () => {
      modalService.closeModal(IMAGE_EDITOR_MODAL_ID);
    };
    const onSave = (file) => {
      handleImageUpload({
        services: { uploadService, devService },
        config,
        publicCommands: getPublicCommands(),
        nodeId,
        files: [file]
      });
      onClose();
    };
    config.onImageEditorOpen && config.onImageEditorOpen();
    setupImageEditor(
      config.imageEditorWixSettings ?? {},
      id,
      src,
      onSave,
      onClose
    );
  }, []);
  return /* @__PURE__ */ React.createElement("div", { id, nofocus: "true" });
};
var image_editor_modal_default = ImageEditorModal;
export {
  image_editor_modal_default as default
};
//# sourceMappingURL=image-editor-modal.js.map
